import { isValidPhoneNumberFormat } from "config/constants";
import { Address, Order, Receiver } from "generated/graphql";
import { isEmpty } from "lodash";

const hasInvalidAddress = (address: Address) =>
  !address || address === undefined || address?.place_id?.length === 0 || address?.address?.length === 0;

const hasInvalidParcels = (orderTest: Order) =>
  !orderTest?.order_parcels.length ||
  !!orderTest?.order_parcels?.find(
    // eslint-disable-next-line camelcase
    ({ parcel_description, parcel_size }) => isEmpty(parcel_description) || isEmpty(parcel_size)
  );

const hasInvalidReceiver = (receiver: Receiver) =>
  !!Object.keys(receiver).find(
    (key) =>
      key !== "receiver_entreprise" &&
      key !== "receiver_specification_address" &&
      key !== "receiver_address" &&
      key !== "receiver_email" &&
      (receiver[key] === undefined || receiver[key] === null || receiver[key]?.length === 0)
  );

const isWarring = (view: Order) => {
  const receiver: Receiver = view?.order_receiver;
  const address: Address = receiver?.receiver_address;
  return (
    hasInvalidAddress(address) ||
    !isValidPhoneNumberFormat(receiver.receiver_phone_number) ||
    hasInvalidReceiver(receiver) ||
    hasInvalidParcels(view)
  );
};

export { isWarring };
